import React, {Component} from 'react';

import "react-table/react-table.css";
import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import couterpart from 'counterpart';

// import MenuComponent2 from './MenuComponent2';
import AuthenticationService from '../services/AuthenticationService';
import MaterialService from '../services/MaterialService';
import ProfileXiCard from './ProfileXiCard';

// import color from '@material-ui/core/colors/amber';

class MaterialList extends Component{
    constructor() {
        super();
        this.state = {
            materials:[],
            show: false,
            defaultQuantity: 400,
            id: 0,
            remainQuantity: 0,
            quantity: 0,
            selectedMaterial: "INIT",
            displayedMaterialList: {
                AXIT: 'Y',
                TAY_MO_BAC: 'Y',
                KEO_BAC: 'Y',
                BAC: 'Y',
                TAY_MO_VANG: 'Y',
                KEO_LAC_KE : 'Y',
                VANG_TRANG_TRI: 'Y',
                VANG_LAC_KE: 'Y',
                PALLADIUM: 'Y',
                HONG_TRANG_TRI: 'Y',
                HONG_LAC_KE: 'Y',
            }
        };
    };

    componentDidMount () {
        this.loadMaterials();  
    }

    loadMaterials(){
        MaterialService.fetchMaterials().then(data => {
            this.setState({ 
                materials:  data
            });
        });
    }

    getWarningInfo(item){
        if (item.quantity > 50){
            return 'green';
        }
        if (item.quantity <= 0){
            return 'red';
        }
        if (item.quantity <= 50){
            return 'yellow';
        }                
    }

    renderMaterialList() {
        if (this.state.materials === undefined || this.state.materials === null || !(this.state.materials instanceof Array)){
            return (<></>);
        }

        if (AuthenticationService.isAdmin()){
            return (
                <table border="1" cellPadding="2" cellSpacing="2" width="100%">
                    <tbody>
                    <tr>
                        <th>
                            { 'STT' }
                        </th>
                        <th>
                            { 'Code' }
                        </th>                
                        <th>
                            { 'Danh mục' }
                        </th> 
                        <th> 
                            { 'Số lượng' }
                        </th> 
                        <th> 
                            { 'CẢNH BÁO' }
                        </th>
                        <th  width="30%"> 
                            { 'PROFILE XI' }
                        </th> 
                    </tr>
                    {this.state.materials.map((item, index) => {
                        if (index % 2 === 0){
                            return (
                            <tr style={{ backgroundColor: "lightblue"}} key={item.code + "_" + index}>
                                <td>
                                    <label className="label_link">{ index + 1 }</label>
                                </td>
                                <td>
                                    <label className="label_link">{ item.code }</label>
                                </td>                          
                                <td>
                                    <label className="label_link">{ item.name }</label>
                                </td>
                                <td>
                                    <label className="label_link float-right" onClick={ this.handleEdit.bind(this, item) }>{ item.quantity }</label>
                                </td>
                                <td style={{ backgroundColor: this.getWarningInfo(item) }} width="5%">
                                    &nbsp;
                                </td>
                                <td cellPadding="0">
                                    <ProfileXiCard profileXiId={item.profileXiId } />
                                </td>              
                            </tr>
                            )
                        } else {
                            return (
                            <tr style={{ backgroundColor: "white"}} key={item.code + "_" + index}>
                                <td>
                                    <label className="label_link">{ index + 1 }</label>
                                </td>
                                <td>
                                    <label className="label_link">{ item.code }</label>
                                </td>
                                <td>
                                    <label className="label_link">{ item.name }</label>
                                </td>
                                <td style={{ alignContent: "right"}}>
                                    <label className="label_link float-right" onClick={ this.handleEdit.bind(this, item) }>{ item.quantity }</label>
                                </td>
                                <td style={{ backgroundColor: this.getWarningInfo(item) }}  width="5%">
                                    &nbsp;
                                </td>
                                <td cellPadding="0">
                                    <ProfileXiCard profileXiId={item.profileXiId } />
                                </td>           
                            </tr>
                            )            
                        }
                    })
                }
                </tbody>
            </table>);
        }
        let count = 1;
        return (
            <table border="1" cellPadding="2" cellSpacing="2"  width="100%">
                <tbody>
                <tr>
                    <th>
                        { 'STT' }
                    </th>
                    <th>
                        { 'Code' }
                    </th>                    
                    <th>
                        { 'Danh mục' }
                    </th>
                    <th>
                        { 'Số lượng' }
                    </th>
                    <th>
                        { 'CẢNH BÁO' }
                    </th>
                    <th> 
                        { 'PROFILE XI' } - { this.state.selectedMaterial }
                    </th> 
                </tr>
                {this.state.materials.map((item, index) => {
                    if (this.isMaterialVisible(item.code)) {
                        count++;
                        console.log("Count: " + count);
                        if (count % 2 === 0){
                            return (
                            <tr style={{ backgroundColor: "lightblue"}} key={item.code + "_" + index}>
                                <td>
                                    <label className="label_link">{ index + 1 }</label>
                                </td>
                                <td>
                                    <label className="label_link">{ item.code }</label>
                                </td>                        
                                <td>
                                    <label className="label_link">{ item.name }</label>
                                </td>
                                <td style={{ alignContent: "right"}}>
                                    <label className="float-right">{ item.quantity }</label>
                                </td>
                                <td style={{ backgroundColor: this.getWarningInfo(item) }} width="5%">
                                    &nbsp;
                                </td>
                                <td cellPadding="0">
                                    <ProfileXiCard profileXiId={item.profileXiId } />
                                </td>               
                            </tr>
                            )
                        } else {
                            return (
                            <tr style={{ backgroundColor: "white"}} key={item.code + "_" + index}>
                                <td>
                                    <label className="label_link">{ index + 1 }</label>
                                </td>
                                <td>
                                    <label className="label_link">{ item.code }</label>
                                </td>
                                <td>
                                    <label className="label_link">{ item.name }</label>
                                </td>
                                <td style={{ alignContent: "right"}}>
                                    <label className="float-right">{ item.quantity }</label>
                                </td>
                                <td style={{ backgroundColor: this.getWarningInfo(item) }} width="5%">
                                    &nbsp;
                                </td>
                                <td>
                                    <ProfileXiCard profileXiId={item.profileXiId } />
                                </td>       
                            </tr>
                            )            
                        }
                    }
                })
            }
            </tbody>
        </table>);
    }

    handleQuantityChange(e){
        var value = e.target.value;
        this.setState({                 
            quantity: value                   
        });
    }

    handleEdit(item){
        this.setState({ show: true, remainQuantity:  item.quantity, quantity: 400, id: item.id });
    }

    handleClose(){
        this.setState({ show: false });
    }

    saveInfo(){
        this.setState({ show: false });
        MaterialService.updateQuantity({id: this.state.id, quantity: this.state.quantity }).then(() => {
            this.loadMaterials();
        });
    }

    refreshMe(){
        this.loadMaterials();
    }

    refreshProfileXis(selectedMaterial){
        this.setState({
            selectedMaterial: selectedMaterial,
            displayedMaterialList: this.getProfileBy(selectedMaterial),
        });
    }

    getProfileBy(selectedXiMode){
        if (undefined === selectedXiMode || 'INIT' === selectedXiMode || 'XI_LOI' === selectedXiMode){
            return {
                AXIT: 'Y',
                TAY_MO_BAC: 'Y',
                KEO_BAC: 'Y',
                BAC: 'Y',
                TAY_MO_VANG: 'Y',
                KEO_LAC_KE : 'Y',
                VANG_TRANG_TRI: 'Y',
                VANG_LAC_KE: 'Y',
                PALLADIUM: 'Y',
                HONG_TRANG_TRI: 'Y',
                HONG_LAC_KE: 'Y',
            }
        }
        if ('BAC' === selectedXiMode){
            return {
                AXIT: 'Y',
                TAY_MO_BAC: 'Y',
                KEO_BAC: 'Y',
                BAC: 'Y',
                TAY_MO_VANG: 'N',
                KEO_LAC_KE : 'N',
                VANG_TRANG_TRI: 'N',
                VANG_LAC_KE: 'N',
                PALLADIUM: 'N',
                HONG_TRANG_TRI: 'N',
                HONG_LAC_KE: 'N',
            }
        }
        if ('VANG_LAC_KE' === selectedXiMode){
            return {
                AXIT: 'Y',
                TAY_MO_BAC: 'N',
                KEO_BAC: 'N',
                BAC: 'N',
                TAY_MO_VANG: 'Y',
                KEO_LAC_KE : 'Y',
                VANG_TRANG_TRI: 'Y',
                VANG_LAC_KE: 'Y',
                PALLADIUM: 'Y',
                HONG_TRANG_TRI: 'N',
                HONG_LAC_KE: 'N',
            }
        }
        if ('VANG_TRANG_TRI' === selectedXiMode){
            return {
                AXIT: 'Y',
                TAY_MO_BAC: 'N',
                KEO_BAC: 'N',
                BAC: 'N',
                TAY_MO_VANG: 'Y',
                KEO_LAC_KE : 'Y',
                VANG_TRANG_TRI: 'Y',
                VANG_LAC_KE: 'Y',
                PALLADIUM: 'Y',
                HONG_TRANG_TRI: 'N',
                HONG_LAC_KE: 'N',
            }
        }
        if ('HONG_LAC_KE' === selectedXiMode){
            return {
                AXIT: 'Y',
                TAY_MO_BAC: 'N',
                KEO_BAC: 'N',
                BAC: 'N',
                TAY_MO_VANG: 'Y',
                KEO_LAC_KE : 'Y',
                VANG_TRANG_TRI: 'N',
                VANG_LAC_KE: 'N',
                PALLADIUM: 'Y',
                HONG_TRANG_TRI: 'Y',
                HONG_LAC_KE: 'Y',
            }
        }
        if ('HONG_TRANG_TRI' === selectedXiMode){
            return {
                AXIT: 'Y',
                TAY_MO_BAC: 'N',
                KEO_BAC: 'N',
                BAC: 'N',
                TAY_MO_VANG: 'Y',
                KEO_LAC_KE : 'Y',
                VANG_TRANG_TRI: 'N',
                VANG_LAC_KE: 'N',
                PALLADIUM: 'Y',
                HONG_TRANG_TRI: 'Y',
                HONG_LAC_KE: 'Y',
            }
        }
        return {
            AXIT: 'N',
            TAY_MO_BAC: 'N',
            KEO_BAC: 'N',
            BAC: 'N',
            TAY_MO_VANG: 'N',
            KEO_LAC_KE : 'N',
            VANG_TRANG_TRI: 'N',
            VANG_LAC_KE: 'N',
            PALLADIUM: 'N',
            HONG_TRANG_TRI: 'N',
            HONG_LAC_KE: 'N',
        }
    }

    isMaterialVisible(materialCode){
        if (AuthenticationService.isSupervisor()) {
            return true;
        }

        if (this.state.displayedMaterialList[materialCode] === 'Y'){
            return true;
        }
        return false;
    }        

    render(){
        if(!AuthenticationService.isAdmin() && !AuthenticationService.isSupervisor() && !AuthenticationService.isXi()){
            return (<div>Unauthorized access.</div>);
        }
        return (
            <div>
                <div className="row" style={{ margin: "20px"}}>
                    <div className="col-12">
                        { this.renderMaterialList() }
                    </div>
                </div>
                <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
                  <Modal.Header closeButton>
                      <Modal.Title>Nhập nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body> 
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_no_remain') } : </span>
                            </div>                        
                            <div className="col-6">
                                <label>{this.state.remainQuantity} </label>
                            </div>
                        </div>                                             
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_no_new') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="quantity" defaultValue={this.state.defaultQuantity} onChange={this.handleQuantityChange.bind(this)}/>
                            </div>
                        </div>                     
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.saveInfo.bind(this)}>OK</Button>  
                  </Modal.Footer>
              </Modal>
            </div>
        );
    }
}

export default MaterialList;
